import RemoveCircleOutline from '@mui/icons-material/RemoveCircleOutline'
import {
  Button,
  CardActionArea,
  CardContent,
  IconButton,
  Skeleton,
  Stack,
  Typography,
} from '@mui/material'
import { LandThumbnail } from 'consts/Theme'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export const EditBoundaryOverlaySkeleton = () => {
  const navigate = useNavigate()
  const { t } = useTranslation('impact/EditBoundaryOverlay')
  return (
    <>
      <CardContent sx={{ padding: 3 }}>
        <Stack direction="row" spacing={1.5} pb={3}>
          <LandThumbnail landProfile={{ name: 'unknown' }} height={36} width={36} />
          <Stack direction="column">
            <Typography variant="body1">
              <Skeleton />
            </Typography>
          </Stack>
        </Stack>
        <Stack spacing={2} alignItems="start" style={{ pointerEvents: 'all', width: '100%' }}>
          <Skeleton height="40px" width="100%" />

          <Stack component="ul" spacing={1} sx={{ width: '100%' }}>
            <Stack component="li" direction="row" spacing={2} alignItems="stretch">
              <Skeleton height="40px" width="100%" />
              <Skeleton height="40px" width="100%" />
              <IconButton disabled>
                <RemoveCircleOutline />
              </IconButton>
            </Stack>
          </Stack>
          <Button color="secondary" disabled>
            {t('addCrop')}
          </Button>
          <Skeleton height="40px" width="100%" />
        </Stack>
      </CardContent>
      <CardActionArea
        sx={{ padding: 2, display: 'flex', justifyContent: 'space-between' }}
        style={{ pointerEvents: 'none' }}
        component="div"
      >
        <Button
          onClick={() => navigate(-1)}
          variant="text"
          color="secondary"
          style={{ pointerEvents: 'all' }}
        >
          {t('cancel')}
        </Button>
        <Button disabled variant="outlined" color="secondary">
          {t('save')}
        </Button>
      </CardActionArea>
    </>
  )
}
